__turbopack_context__.v({
  "freeBox": "PlasmicDescription-module__s5n-hG__freeBox",
  "root": "PlasmicDescription-module__s5n-hG__root",
});
